// extracted by mini-css-extract-plugin
export default {"root":"QM3WDQahIk2mhNDPIpEm","placeHolderShimmer":"QV8kaReiSy06GhhTJZJ7"};